<template>
    <data-view :tableColumns="tableColumns" :tableData="items" :actionButtons="actionButtons" titleKey="ClientName"
        @sortChanged="event => emit('sortChanged', event)" @loadMore="emit('loadMore')">
        <template #col-entry_date="{ row }">
            {{ renderDate(row.entry_date) }}
        </template>

        <template #col-amount="{ row }">
            <span :class="row.type == 'CREDIT'? 'custom-success' : 'custom-danger'">{{ formatCurrency(row.amount, row.currency) }}</span>
        </template>
        <template #col-status="{ row }">
            <span :class=" STATUS_LIST[row.status] || STATUS_LIST['unlinked']"> {{ row.status | capitalize}}</span> 
        </template>
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView'
import { formatCurrency, renderDate } from '@/utils/helpers'

const emit = defineEmits(['sortChanged', 'loadMore','linkExpenses'])

const props = defineProps({
    items: { type: Array, default: () => ([]) }
})

const STATUS_LIST = {
    unlinked:'custom-danger',
    completed: 'custom-success',
    linked:'custom-warning'
}

const tableColumns = ref([
    { key: 'entry_date', label: 'entry_date', sortable: false },
    { key: 'value_date', label: 'date', sortable: false },
    { key: 'type', label: 'Tipo', sortable: false },
    { key: 'code', label: 'code', sortable: false },
    { key: 'ref', label: 'reference', sortable: false },
    { key: 'amount', label: 'amount', sortable: false },
    { key: 'status', label: 'status', sortable: false }

])
const actionButtons = ref([
    { text: 'details', icon: 'LinkIcon', color: 'primary', permissions: ['IU HSBC REPORT'],hideIf: row => row.type == 'CREDIT', onClick: row => emit('linkExpenses', row) }
])

</script>

<style></style>
